module.exports = __webpack_public_path__ + "static/media/wulingstore.8ffac351.png";